module.exports = __webpack_public_path__ + "static/img/dh.65122fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/dh.png
// module id = EWwj
// module chunks = 1